//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from "lodash";

const clone = require("lodash.clone");

import { DecisionTree } from "./utils/DecisionTree";
import { CesHttpClient, Continuum } from "./CesHttpClient";
import { DefaultChartDefinition } from "./utils/DefaultChartDefinition.json";

import TheServerDialog from "./components/TheServerDialog";
import TheScenarioDialog from "./components/TheScenarioDialog";
import TheSiteComDialog from "./components/TheSiteComDialog";
import TheControlPoints from "./components/TheControlPoints";
import TheDrillPosition from "./components/TheDrillPosition";
import TheDrillSetup from "./components/TheDrillSetup";
import TheDrillMovement from "./components/TheDrillMovement";
import TheLogs from "./components/TheLogs";
import TheTrajectoryView from "./components/TheTrajectoryView";
import TheVsMDView from "./components/TheVsMDView";
import TheStatusBar from "./components/TheStatusBar";
import Setting from "./components/setting";
import TheMapTrajectoryViewSmall from "./components/TheMapTrajectoryViewSmall";

import Vue from "vue";
import { mapState, mapActions, mapGetters } from "vuex";

export default {
  name: "App",
  data: function() {
    return {
      isDevelopment: process.env.NODE_ENV === 'development',
      isLoadingProject: false,
      tabActive: null,
      tabs: ["Controls", "Settings for Logs"],
      leftDrawer: false,
      httpClient: null,
      tree: null,
      curtainGridC: null, // a continuum object
      plannedLogData: null, // a continuum object
      imageLog: null, // a continuum object
      defaultChartDefinition: DefaultChartDefinition,
      chartDefinition: {
        charts: [
          {
            curtainProperty: [""],
            curtainColorMap: [""],
            imageLogProperty: [""],
            imageLogColorMap: [""],
            logMn: ["Z", "Z"],
            logLineName: ["Planned Path", "Drilled Path"],
            logLineColor: ["black", "red"],
            logLineType: ["dash", "solid"],
            logLineWidth: [1.5, 2.0],
            logLineFill: [false, false],
            drawUntil: ["Fwd", "DrillBit"], // allowed values: DrillBit (default), Fwd, Long
            logSide: ["left", "left"],
            logOverLaying: ["", ""]
          }
        ]
      }
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      window.addEventListener("keyup", event => {
        if (event.altKey && event.keyCode === 78) {
          // console.log("Alt-N shortcut pressed");
        }
      });
    });
    if(process.env.NODE_ENV === "development") {
      this.connectToServer("http://localhost:9000"); // for dev
      //this.loadScenario('GK-new-5');
      //this.loadScenario('GK-new-6-test');
      this.loadScenario('GinaKrog-Perturbations');
    }
  },
  methods: {
    ...mapActions("layout", ["updateSetting"]),
    ...mapActions("drilling", ["currentFwdLogsJSONChanged"]),
    connectToServer: function(url) {
      this.attemptServerConnection(url);
    },
    attemptServerConnection: async function (inputURL) {
      this.httpClient = new CesHttpClient(inputURL, "", true);

      try {
        let response = await this.httpClient.testServerConnection(); // took around 500 ms
        console.log(response);
        if (!response.status) return;
      } catch (e) {
        let msg = "Could not connect to GSTS server at " + inputURL + "Error: " + e;
        console.log(msg);
        this.updateMsgToUser({ msg: msg, type: "error" });
        this.httpClient = null;
        return;
      }

      this.httpClient
        .getAvailableGSTSScenarios()
        .then(scenarios => (this.$store.commit("preferences/updateScenarios", scenarios)))
        .then(this.$store.commit("preferences/updateScenarioDialog", true))
        .catch(e => {
          let msg = "No GSTS scenarios available! " + e.message;
          console.log(msg);
          alert(msg);
          });
    },
    loadScenario: async function(scenarioId) {
      console.log("loadScenario() been called." + scenarioId);
      if (this.tree != null) {
        this.reset();
      }
      this.updateProgress(1);
      this.$store.commit("preferences/updateScenarioId", scenarioId);
      this.$store.commit("preferences/updateSessionId");

      this.isLoadingProject = true;
      let scenarioJSON = await this.httpClient.recieveGSTSScenarioJSON(scenarioId); // take 9 seconds in local server
      this.$store.commit("preferences/updateScenarioJSON", scenarioJSON);
      if(this.defaultSelectedCurtainProperties && this.defaultSelectedCurtainProperties.length > 0){
        console.log(JSON.stringify("default selected curtain properties: " + this.defaultSelectedCurtainProperties));
        this.$store.commit("curtains/updateSelectedCurtainProperties", this.defaultSelectedCurtainProperties);
      }
      if(this.defaultSelectedLogProperties && this.defaultSelectedLogProperties.length > 0){
        console.log(JSON.stringify("default selected log properties: " + this.defaultSelectedLogProperties));
        this.$store.commit("logs/updateSelectedLogQuantities", this.defaultSelectedLogProperties);
      }
      if(this.defaultSelectedImageLogProperty && this.defaultSelectedImageLogProperty.length > 0){
        console.log(JSON.stringify("default selected imagelog property: " + this.defaultSelectedImageLogProperty));
        this.$store.commit("curtains/updateSelectedImageLogProperty", this.defaultSelectedImageLogProperty);
      }

      //await this.loadPlannedLogData();
      await this.httpClient.getColormapList();

      this.tree = new DecisionTree(this.scenarioJSON);

      if (this.preferences.connectedSiteCom) {
        this.initSiteComConnection();
      }
      this.isLoadingProject = false;
      this.updateProgress(-1);
      this.updateGUI();
    },
    loadCurtainGridC: async function() {
      this.updateProgress(1);

      try {
        console.log("---------- load continuum CurtainGridC ---------------");
        this.curtainGridC = await this.httpClient.getContinuumByTag("CurtainGridC");
        const geometry = await this.httpClient.downloadContinuumPropertyVtk(this.curtainGridC, this.selectedCurtainProperties[0],"vtk");
        const texture = await this.httpClient.downloadContinuumPropertyVtk(this.curtainGridC, this.selectedCurtainProperties[0],"png");
        this.$store.commit("curtains/updateGeometryForVtk", geometry);
        this.$store.commit("curtains/updateTextureForVtk", texture);

      } catch(e) {
        console.log("!!! Error: Failed to load continuum CurtainGridC: " + e.message);
      }

      this.updateProgress(-1);
    },
    loadPlannedLogData: async function() {
      if (
        "cesModel" in this.scenarioJSON &&
        "plannedLog" in this.scenarioJSON.cesModel &&
        "continuum" in this.scenarioJSON.cesModel.plannedLog
      ) {
        const tag = this.scenarioJSON.cesModel.plannedLog.continuum;
        try {
          console.log("---------- load Planned Log Data ---------------");
          this.plannedLogData = await this.httpClient.getContinuumByTag(tag);
          for (var id in this.plannedLogData._property) {
            const prop = this.plannedLogData._property[id]._name;
            // Only downloads needed property
            if (this.plannedLogDataPropertyNeeded.includes(prop)){
              await this.httpClient.downloadContinuumPropertyBinary(this.plannedLogData, prop);
            }
          }
        } catch (e) {
          console.log("!!!Failed to load Planned Log Data: " + e.message);
        }
      }
    },
    loadImageLog: async function() {
      this.updateProgress(1);
      let tag = 'imageLog';
      let processTag = 'GenerateImageLog';
      // let diameter = 10; // this.diameterImageLog

      // // Re-generate imagelog from well TrainingInterfaceDataFwd0
      // try {
      //   let res = await this.httpClient.executeProcess(processTag);
      //   // console.log("Re-generate the imageLog: " + JSON.stringify(res));
      // } catch (e) {
      //   console.log("!!! Failed to re-generate the imageLog" + e.message);
      // }

      // Load pre-generated image logs
      // This is temporary solution for Gina Krog training dataset.
      console.log(JSON.stringify(this.chosenDrillSetupValues))
      if(this.chosenDrillSetupValues.TRJSWTCH1 == 1 && this.diameterImageLog) {
        tag = 'imageLogTRJ1' + '_' + this.diameterImageLog;
      } else if (this.chosenDrillSetupValues.TRJSWTCH1 == 2 && this.diameterImageLog) {
        tag = 'imageLogTRJ2' + '_' + this.diameterImageLog;
      }
      console.log("image log tag = " + tag + ";" + " the diameter = " + this.diameterImageLog);

      try {
        console.log("---------- load continuum imageLog ---------------");
        this.imageLog = await this.httpClient.getContinuumByTag(tag);
        console.log(this.imageLog);
        // update PropetyJSON file
        if (
          this.imageLog && this.imageLog._property.length > 0 &&
          _.isEqual(this.imageLogPropertyJSON, this.imageLog._property) ==
          false
        ) {
            this.$store.commit("curtains/updateImageLogPropertyJSON", this.imageLog._property);
        }
      } catch(e) {
        console.log("!!!Failed to load continuum imageLog:  " + e.message);
      }

      this.updateProgress(-1);
    },
    updateGUI: function() {
      if (!this.tree) {
        return;
      }
      this.updateProgress(1);
      this.updateControlPointsPanel();
      this.updateDrillSetupPanel();
      this.updateProgress(-1);
    },
    openServerDialog: function() {
      window.location.reload();
    },
    connectSiteCom: function() {
      this.$store.commit("preferences/updateConnectedSiteCom");
      if (this.preferences.connectedSiteCom) {
        this.$store.commit("preferences/updateSiteComDialog", true);
      }
      let msg = "Connect to SiteCom " + this.preferences.connectedSiteCom;
      console.log(msg);
      // this.updateMsgToUser({ msg: msg, type: "info" });
    },
    initSiteComConnection: function() {
      this.httpClient.initSitecomSession(
        this.preferences.scenarioId,
        this.preferences.sessionId,
        this.siteComUserInfo.username,
        this.siteComUserInfo.password
      );
      this.updateSiteComLogs();
    },
    uniformisedVariableName: function(varName) {
      varName = varName.startsWith("AZ") ? "AZ" : varName;
      varName = varName.startsWith("IN") ? "IN" : varName;
      varName = varName.startsWith("MD") ? "MD" : varName;
      return varName;
    },
    updateControlPointsPanel: function() {
      this.updateControlPoints(""); // Clean the control points first
      this.tree.decisionHistory().forEach(
        function(traverseNode) {
          var item = {
            title: "title",
            subtitle: "no comment"
          };
          item.title = traverseNode.description;
          if (traverseNode.comment != null && traverseNode.comment.length > 0)
            item.subtitle = traverseNode.comment;

          this.updateControlPoints(item);
        }.bind(this)
      );
    },
    updateDrillSetupPanel: function() {
      let variableChoices = {};
      this.tree.getCurrentNode().alternatives.forEach(function(alternative) {
        _.forOwn(alternative.varValues, function(val, key) {
          if (!_.has(variableChoices, key)) {
            variableChoices[key] = new Set();
          }
          let cSet = variableChoices[key];
          cSet.add(val);
        });
      });

      this.updateDrillSetup(""); // clean DrillSetup first

      _.forOwn(
        variableChoices,
        function(value, key) {
          this.updateDrillSetup({
            id: key,
            values: Array.from(value).sort((a, b) => a - b)
          })
        }.bind(this)
      );
    },
    chosenDrillSetupValuesChanged: async function() {
      if (!this.tree) return;

      this.updateProgress(1);

      if (this.tree.getCurrentControlPointPosition()) {
        this.updateCurrentControlPointMD(this.tree.getCurrentControlPointPosition());
      } else if (this.currentControlPointMD) {
        this.updateCurrentControlPointMD(this.currentControlPointMD + this.drillSegmentLength);
      }

      if (this.httpClient) {
        await this.requestFwdLogsFromServer();
        await this.requestHDF5GridFromServer();
        if(this.showImageLog) await this.loadImageLog();
        this.rebuildChartDefinitions();
      }

      this.updateProgress(-1);
    },

    requestFwdLogsFromServer: async function() {
      if(!this.tree) return;

      let logs = this.tree.getLogsForSetOfVariables(this.chosenDrillSetupValues);
      if (!logs) {
        console.log("!!! Error: Failed to get Logs for set of variables");
        return;
      }

      if (this.lastRequestedLogs && this.lastRequestedLogs == logs) {
        console.log(logs + " equal to " + this.lastRequestedLogs);
        return;
      }

      let currentFwdLogsJSON = await this.httpClient.requestFwdLogsFromServer(logs)
      // console.log(currentFwdLogsJSON)
      this.currentFwdLogsJSONChanged(currentFwdLogsJSON);
      this.$store.commit("drilling/updateLastRequestedLogs", logs);
    },

    requestHDF5GridFromServer: async function() {
      if(!this.tree) return;

      let filename = this.tree.sourceFile;
      let currentGridPointers = this.tree.getGridPointersForSetOfVariables(
        this.chosenDrillSetupValues
      );
      if (!currentGridPointers || !filename) {
        console.log("!!! Error: Failed to get Grids for set of variables");
        return;
      }

      this.updateProgress(1);

      // Only load selected curtain properties.
      let currentRequestedPointers = [];
      for (const property of this.selectedCurtainProperties) {
        for (const pointer of currentGridPointers) {
          if (pointer.includes(property)) {
            currentRequestedPointers.push(pointer);
            break;
          }
        }
      }

      if (this.lastRequestedPointers && this.lastRequestedPointers == currentRequestedPointers) {
        console.log(currentRequestedPointers + " equal to " + this.lastRequestedPointers);
        return;
      }
      for (const pointer of currentGridPointers) {
        await this.httpClient.requestHDF5GridFromServer(filename, pointer);
      }

      this.updateProgress(-1);

      await this.loadCurtainGridC();

      this.$store.commit("drilling/updateLastRequestedPointers", currentRequestedPointers);
    },
    fastBack: function() {
      this.updateExtraLogs(""); // clean extra logs
      if (this.drillingInProgress) {
        this.updateDrillingInProgress(false);
        this.updateDrillSegmentProgress(0);
      } else {
        this.tree.stepBack();
      }
      this.updateGUI();
      this.$store.commit("drilling/updateIsDrillStep", true); // Required to trigger re-build chart at VsMDView
      this.streamFwdLogToLog();
    },
    drillStepBack: function() {
      this.updateDrillSegmentProgress(this.drillSegmentProgress - this.$store.state.drilling.stepSize);
      if (this.drillSegmentProgress <= 0) {
        this.fastBack();
      } else {
        this.$store.commit("drilling/updateIsDrillStep", true);
        this.streamFwdLogToLog();
      }
    },
    drillStep: function() {
      this.updateDrillSegmentProgress(this.drillSegmentProgress + this.$store.state.drilling.stepSize);
      if (this.drillSegmentProgress >= this.drillSegmentLength - 1e-5) {
        this.fastFwd();
      } else {
        this.$store.commit("drilling/updateIsDrillStep", true);
        this.streamFwdLogToLog();
      }
    },
    fastFwd: function() {
      if (this.drillingInProgress) {
        this.updateExtraLogs(""); // clean extra logs
        let child = this.tree.getChildForSetOfVariables(
          this.chosenDrillSetupValues
        );
        if (child) {
          this.updateDrillingInProgress(false);
          this.updateDrillSegmentProgress(0);
          this.tree.moveToNode(child);
        } else {
          this.updateDrillSegmentProgress(this.drillSegmentLength);
          if (this.logPlotData) {
            this.updateCurrentMDindex(this.logPlotData["MD"].d.length - 1);
          }
          this.$store.commit("drilling/updateIsDrillStep", true); // Required to trigger re-build chart at VsMDView
          this.streamFwdLogToLog();

          let msg = "End of drill segment reached with no more choices available!"
          this.updateExtraLogs(msg); // clean extra logs
        }
        this.updateGUI();
      } else {
        this.updateExtraLogs(""); // clean extra logs
        this.tree.stepFwd();
        this.updateGUI();
      }
    },
    drillSetupConfirmed: async function() {
      this.updateDrillingInProgress(true);
      this.updateDrillSegmentProgress(0);

      this.updateGUI();
    },

    filterChartStyle: function(defaultChartStyles, prop) {
      for (let i = 0, iLen = defaultChartStyles.length; i < iLen; i++) {
        if (prop == defaultChartStyles[i].name) {
          return defaultChartStyles[i].style;
        }
      }
      // The last item in json file is the default style
      return defaultChartStyles[defaultChartStyles.length - 1].style;
    },

    rebuildLogGroup: function(selectedLogQuantities, defaultChartDefinition) {
      var activeLogGroup = [];
      for (
        let i = 0, iLen = defaultChartDefinition.logGroup.length;
        i < iLen;
        i++
      ) {
        // using Array intersection in ES6
        // https://medium.com/@alvaro.saburido/set-theory-for-arrays-in-es6-eb2f20a61848
        let tempLogGroup = [];
        tempLogGroup = clone(defaultChartDefinition.logGroup[i]);
        let intersection = selectedLogQuantities.filter(x =>
          tempLogGroup.member.includes(x)
        );
        if (intersection.length > 1) {
          tempLogGroup.member = intersection;
          activeLogGroup.push(tempLogGroup);
        }
      }
      return activeLogGroup;
    },

    rebuildChartDefinitions: function() {
      if (!this.logPlotData) return;
      var newcharts = [];

      // set default chart definition for Maximum two curtains
      var curtainColorMaps = [];
      for (var i = 0; i < this.selectedCurtainProperties.length; i++) {
        var curtainStyle = {};
        curtainStyle = this.filterChartStyle(
          this.defaultChartDefinition.curtain,
          this.selectedCurtainProperties[i]
        );
        curtainColorMaps.push(curtainStyle.colorMap);
      }
      console.log("Curtains colormaps: " + JSON.stringify(curtainColorMaps));
      newcharts = [
        // for curtain
        {
          curtainProperty: this.selectedCurtainProperties,
          curtainColorMap: curtainColorMaps,
          imageLogProperty: [""],
          imageLogColorMap: [""],
          logMn: ["Z", "Z"],
          logLineName: ["Planned Path", "Drilled Path"],
          logLineColor: ["black", "red"],
          logLineType: ["dot", "solid"],
          logLineWidth: [1.5, 2.0],
          logLineFill: [false, false],
          drawUntil: ["Fwd", "DrillBit"], // allowed values: DrillBit (default), Fwd, Long
          logSide: ["left", "left"],
          logOverLaying: ["", ""]
        }
      ];

      // rebuild imagelog chart definition
      // Only one image log is supported
      let imageLogColorMap = "";
      let imageLogStyle = {};
      imageLogStyle = this.filterChartStyle(this.defaultChartDefinition.curtain, this.selectedImageLogProperty);
      imageLogColorMap = imageLogStyle.colorMap;
      console.log("imageLogColorMaps " + JSON.stringify(imageLogColorMap));
      let imagelogChart = {
        curtainProperty: [""],
        curtainColorMap: [""],
        imageLogProperty: [this.selectedImageLogProperty],
        imageLogColorMap: [imageLogColorMap],
        logMn: [""],
        logLineName: [""],
        logLineColor: [""],
        logLineType: [""],
        logLineWidth: [0],
        logLineFill: [false],
        drawUntil: ["Fwd"], // allowed values: DrillBit (default), Fwd, Long
        logSide: ["left"],
        logOverLaying: [""]
      };
      newcharts.push(imagelogChart);

      // rebuild the logGroup based on the selected log quantities and the default log group info
      var logGroup = [];
      logGroup = this.rebuildLogGroup(
        this.selectedLogQuantities,
        this.defaultChartDefinition
      );

      for (var i = 0; i < this.selectedLogQuantities.length; i++) {
        let q = this.selectedLogQuantities[i].split(" ")[0];
        let logStyle = {};
        logStyle = this.filterChartStyle(this.defaultChartDefinition.log, q);

        // find out the index of q in logGroup
        var qLogGroupIndex = -1;
        var qLogGroup = [];
        for (let j = 0; j < logGroup.length; j++) {
          if (logGroup[j].member.indexOf(q) != -1) {
            qLogGroupIndex = logGroup[j].member.indexOf(q);
            qLogGroup = logGroup[j].member;
            break; // !! By default, one log can only belong to one group
          }
        }
        // only build the chartdefinition for qLogGroupIndex = -1 & 0
        // if qLogGroupIndex = -1, means this log is not grouped
        // if qLogGroupIndex = 0, means this log is the first element of the group
        // if qLogGroupIndex > 0, means this log is in one group but not the first element in this group
        if (qLogGroupIndex === -1) {
          var c = {
            curtainProperty: "",
            curtainColorMap: "",
            imageLogProperty: [""],
            imageLogColorMap: [""],
            logMn: [q, ""],
            logLineName: [logStyle.lineName, ""],
            logLineColor: [logStyle.lineColor, ""],
            logLineType: [logStyle.lineType, ""],
            logLineWidth: [logStyle.lineWidth, 2.0],
            logLineFill: [logStyle.lineFill, false],
            drawUntil: ["DrillBit", "DrillBit"],
            logSide: [logStyle.side, ""],
            logOverLaying: ["", ""]
          };
          newcharts.push(c);
        } else if (qLogGroupIndex === 0) {
          let qq = qLogGroup[1];
          let qqLogStyle = {};
          qqLogStyle = this.filterChartStyle(
            this.defaultChartDefinition.log,
            qq
          );

          var c = {
            curtainProperty: "",
            curtainColorMap: "",
            logMn: [q, qq],
            logLineName: [logStyle.lineName, qqLogStyle.lineName],
            logLineColor: [logStyle.lineColor, qqLogStyle.lineColor],
            logLineType: [logStyle.lineType, qqLogStyle.lineType],
            logLineWidth: [logStyle.lineWidth, qqLogStyle.lineWidth],
            logLineFill: [logStyle.lineFill, qqLogStyle.lineFill],
            drawUntil: ["DrillBit", "DrillBit"],
            //logSide: [logStyle.side, qqLogStyle.side]
            logSide: ["left", "right"],
            logOverLaying: ["", q]
          };
          newcharts.push(c);
        }
      }

      var newlabels = [];

      var CPs = {
        markerName: "Control Points",
        markerText: [],
        textPosition: "top",
        posMD: [],
        posZ: []
      };
      this.tree.decisionHistory().forEach(
        function(traverseNode) {
          CPs.markerText.push(traverseNode.description);
          CPs.posMD.push(traverseNode.MDposition);
          CPs.posZ.push(NaN); // NaN default to traj depth
        }.bind(this)
      );
      newlabels.push(CPs);

      this.chartDefinition = {
        charts: newcharts,
        labels: newlabels
      };
    },

    streamFwdLogToLog: function() {
      if (!this.logPlotData) {
        return;
      }

      const MD = this.drillSegmentProgress;
      const MDl = this.drillSegmentLength;

      const MDdata = this.logPlotData["MD"].d;
      const MDmax = MDdata[MDdata.length - 1];

      if (this.currentControlPointMD == null) {
        const MDindex = MDdata.findIndex(function(el) {
          return el >= MDmax + MD - MDl;
        });
        this.updateCurrentMDindex(MDindex);
      } else {
        const cCPMD = this.currentControlPointMD;
        const MDindex = MDdata.findIndex(function(el) {
          return el >= cCPMD + MD;
        });
        this.updateCurrentMDindex(MDindex);

        const FwdMDindex = MDdata.findIndex(function(el) {
          return el >= cCPMD + MDl;
        });

        if (FwdMDindex >= 0) {
          this.updateCurrentFwdMDindex(FwdMDindex);
        } else {
          this.updateCurrentFwdMDindex(MDdata.length - 1);
        }
      }

      if (this.preferences.connectedSiteCom) {
        this.updateSiteComLogs();
      }
    },
    updateSiteComLogs: function() {
      if (!this.logPlotData || !this.tree) {
        return;
      }

      let sitecomMDend = this.logPlotData["MD"].d[this.currentMDindex];
      let sitecomMDstart =
        this.lastSitecomMD < sitecomMDend ? this.lastSitecomMD : sitecomMDend;

      let currentNode = this.tree.getCurrentNode();
      let logs = this.tree.getLogsForSetOfVariables(this.chosenDrillSetupValues);
      let trajectories = this.tree.getTrajectoriesForSetOfVariables(
        this.chosenDrillSetupValues
      );

      if (sitecomMDend > sitecomMDstart || sitecomMDend < this.lastSitecomMD) {
        const promise = this.httpClient.sendWitsmlFilesToSiteCom(
          this.preferences.scenarioId,
          this.preferences.sessionId,
          logs,
          trajectories,
          sitecomMDstart,
          sitecomMDend
        );
        this.$store.commit("drilling/updateLastSitecomMD", sitecomMDend);
      }
    },
    updateProgress: function(progress) {
      this.$store.commit("preferences/updateProgress", progress);
    },
    updateControlPoints: function(item) {
      this.$store.commit("drilling/updateControlPoints", item);
    },
    updateDrillingInProgress: function(value) {
      this.$store.commit("drilling/updateDrillingInProgress", value);
    },
    updateDrillSetup: function(value) {
      this.$store.commit("drilling/updateDrillSetup", value);
    },
    updateExtraLogs: function(value) {
      this.$store.commit("messages/updateExtraLogs", value);
    },
    updateMsgToUser: function(msg) {
      alert(msg['msg']);
      this.$store.commit("messages/updateMsgToUser", msg);
    },
    updateDrillSegmentProgress: function(value) {
      this.$store.commit("drilling/updateDrillSegmentProgress", value);
    },
    updateCurrentControlPointMD: function(value) {
      this.$store.commit("drilling/updateCurrentControlPointMD", value);
    },
    updateCurrentMDindex: function(value) {
      this.$store.commit("drilling/updateCurrentMDindex", value);
    },
    updateCurrentFwdMDindex: function(value) {
      this.$store.commit("drilling/updateCurrentFwdMDindex", value);
    },
    reset: function() {
      this.curtainGridC = null;
      this.imageLog = null,
      this.chartDefinition = {
        charts: [
          {
            curtainProperty: [""],
            curtainColorMap: [""],
            imageLogProperty: [""],
            imageLogColorMap: [""],
            logMn: ["", ""],
            logLineName: ["", ""],
            logLineColor: ["", ""],
            logLineType: ["", ""],
            logLineWidth: [2.0, 2.0],
            logLineFill: [false, false],
            logSide: ["left", "right"],
            logOverLaying: ["", ""]
          }
        ]
      };
    },
  },
  computed: {
    ...mapState({
      progress: state => state.preferences.progress,
      preferences: state => state.preferences.global,
      siteComUserInfo: state => state.preferences.siteComUserInfo,
      showImageLog: state => state.preferences.showImageLog,
      scenarioJSON: state => state.preferences.scenarioJSON,
      selectedCurtainProperties: state => state.curtains.selectedCurtainProperties,
      selectedImageLogProperty: state => state.curtains.selectedImageLogProperty,
      diameterImageLog: state => state.curtains.diameterImageLog,
      selectedLogQuantities: state => state.logs.selectedLogQuantities,
      drillingInProgress: state => state.drilling.drillingInProgress,
      chosenDrillSetupValues: state => state.drilling.chosenDrillSetupValues,
      drillSegmentProgress: state => state.drilling.drillSegmentProgress,
      drillSegmentLength: state => state.drilling.drillSegmentLength,
      currentFwdLogsJSON: state => state.drilling.currentFwdLogsJSON,
      logPlotData: state => state.drilling.logPlotData,
      currentMDindex: state => state.drilling.currentMDindex,
      lastRequestedLogs: state => state.drilling.lastRequestedLogs,
      lastRequestedPointers: state => state.drilling.lastRequestedPointers,
      lastSitecomMD: state => state.drilling.lastSitecomMD,
      plannedLogDataPropertyNeeded: state => state.drilling.plannedLogDataPropertyNeeded,
      imageLogPropertyJSON: state => state.curtains.imageLogPropertyJSON,
      messages: state => state.messages,
    }),
    ...mapGetters("preferences", ["appTitle", "defaultSelectedCurtainProperties", "defaultSelectedLogProperties", "defaultSelectedImageLogProperty"]),
  },
  watch: {
    currentFwdLogsJSON: function() {
      if (this.currentFwdLogsJSON) {
        this.streamFwdLogToLog();
      }
    },
    chosenDrillSetupValues: {
      handler: async function() {
        await this.chosenDrillSetupValuesChanged();
      },
      deep: true
    },
    progress: function() {
      console.log("current progress ================= " + this.progress);
    },
    selectedCurtainProperties: {
      handler: async function() {
        // Since only selected curtain properties are loaded,
        // so if selectedCurtainProperties changed, need to request HDF5 Grid from Server.
        if(!this.tree) return;
        await this.requestHDF5GridFromServer();
        this.rebuildChartDefinitions();
      },
      deep: true
    },
    selectedLogQuantities: {
      handler: function() {
        this.rebuildChartDefinitions();
      },
      deep: true
    },
    selectedImageLogProperty: function() {
      this.rebuildChartDefinitions();
    },
    showImageLog: async function() {
      if(this.showImageLog) {
        await this.loadImageLog();
        this.rebuildChartDefinitions();
        if(!this.imageLog) console.log("!!! Image log is null!")
      } else {
        this.imageLog = null;
        if(this.imageLog) console.log("!!! Image log is still here!")
        this.rebuildChartDefinitions();
      }
    }
  },
  components: {
    TheServerDialog,
    TheScenarioDialog,
    TheSiteComDialog,
    TheControlPoints,
    TheDrillPosition,
    TheDrillSetup,
    TheDrillMovement,
    TheLogs,
    TheTrajectoryView,
    TheVsMDView,
    TheStatusBar,
    Setting,
    TheMapTrajectoryViewSmall,
  }
};
